export const colors = {
  contentOnDarkSubtle: "#ffffffb3",
  componentDailyJackpotDefaultBackground: "rgba(28,29,29,0.85)",
  componentDailyJackpotDefaultContent: "#ffffff",
  componentDailyJackpotUrgentContent: "#ffffff",
  componentDailyJackpotUrgentBackground: "rgba(97,1,155,0.85)",
  componentDailyJackpotUrgentPulseContent: "#ffffff",
  componentDailyJackpotUrgentPulseBackground: "rgba(0,78,163,0.85)",
  componentDailyJackpotJustWonContent: "#ffffff",
  componentDailyJackpotJustWonBackground: "rgba(28,29,29,0.85)",
  componentGameLabelNewContent: "#ffffff",
  componentGameLabelNewBackground: "#D22839",
  componentGameLabelNewBorder: "#EA6875",
  componentGameLabelExclusiveContent: "#ffffff",
  componentGameLabelExclusiveBackground: "#7401B7",
  componentGameLabelExclusiveBorder: "#A530F3",
  componentGameLabelJackpotContent: "#ffffff",
  componentGameLabelJackpotBackground: "#0070EB",
  componentGameLabelJackpotBorder: "#64AEFF",
};